import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext.js';
import { TooltipProvider } from './components/ui/tooltip.js';
import App from './App.js';
import './index.css';

console.log('[main.tsx] Mounting application');

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

// Ensure we only create root once
if (!rootElement.hasChildNodes()) {
  console.log('[main.tsx] Creating React root');
  createRoot(rootElement).render(
    <AuthProvider>
      <TooltipProvider>
        <App />
      </TooltipProvider>
    </AuthProvider>
  );
} else {
  console.warn('[main.tsx] Root already has children, skipping render');
}
